import { render, staticRenderFns } from "./TheDebtorIncomeModal.vue?vue&type=template&id=1ce5cf16&"
import script from "./TheDebtorIncomeModal.vue?vue&type=script&lang=js&"
export * from "./TheDebtorIncomeModal.vue?vue&type=script&lang=js&"
import style0 from "./TheDebtorIncomeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports